if (!customElements.get('pdp-conversion-cta')) {
  class PdpConversionCta extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(evt) {
      const trigger = evt.target.closest('[data-pdp-conversion-cta-scroll]');
      if (!trigger) return;

      const hash = this.getSamePageHash(trigger);
      if (!hash || hash === '#') return;

      const target = this.getScrollTarget(hash, {
        usePdpFallback: trigger.hasAttribute('data-pdp-conversion-cta-pdp-fallback'),
        preferPdpAddToCart: trigger.hasAttribute('data-pdp-conversion-cta-pdp-add-to-cart')
      });
      if (!target) return;

      evt.preventDefault();
      this.scrollToTarget(target);

      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', hash);
      }
    }

    getSamePageHash(trigger) {
      const href = trigger.getAttribute('href');
      if (!href || href === '#') return '';

      let url;

      try {
        url = new URL(href, window.location.href);
      } catch (error) {
        return '';
      }

      if (!url.hash || url.hash === '#') return '';

      const currentUrl = new URL(window.location.href);
      if (url.origin !== currentUrl.origin || url.pathname !== currentUrl.pathname || url.search !== currentUrl.search) {
        return '';
      }

      return url.hash;
    }

    getScrollTarget(hash, options = {}) {
      const target = document.getElementById(this.getHashId(hash));
      const addToCartTarget = options.preferPdpAddToCart ? this.getPdpAddToCartTarget() : null;

      if (addToCartTarget) return addToCartTarget;
      if (target || !options.usePdpFallback) return target;

      return this.getPdpAddToCartTarget();
    }

    getPdpAddToCartTarget() {
      return document.querySelector('.cc-main-product product-form')
        || document.querySelector('.cc-main-product .product-info__add-to-cart')
        || document.querySelector('product-form');
    }

    getHashId(hash) {
      try {
        return decodeURIComponent(hash.slice(1));
      } catch (error) {
        return hash.slice(1);
      }
    }

    scrollToTarget(target) {
      const headerOffset = this.getHeaderOffset(target);
      const top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }

    getHeaderOffset(target) {
      if (target.classList.contains('product-options--anchor')) return 0;

      const headerEnd = getComputedStyle(document.documentElement).getPropertyValue('--header-end');
      const parsedHeaderEnd = Number.parseFloat(headerEnd);
      return Number.isFinite(parsedHeaderEnd) ? parsedHeaderEnd + 24 : 24;
    }
  }

  customElements.define('pdp-conversion-cta', PdpConversionCta);
}
